import { generate } from '@/plugins'
import { themeSettings } from '@/theme/settings'
import { local } from '@/utils/storage'
import { addThemeVarsToHtml, createThemeToken, getNaiveTheme, toggleCssDarkMode, toggleGrayscaleMode } from '@/utils/theme'

export const useThemeStore = defineStore('theme-store', {
  state: () => {
    const scope = effectScope()
    const osTheme = usePreferredColorScheme()
    const settings = ref<App.Theme.ThemeSetting>(themeSettings)
    const darkMode = computed(() => {
      if (settings.value.themeScheme === 'auto') {
        return osTheme.value === 'dark'
      }
      return settings.value.themeScheme === 'dark'
    })
    const grayscaleMode = computed(() => settings.value.grayscale)
    const themeColors = computed(() => {
      const { themeColor, otherColor } = settings.value
      const colors: App.Theme.ThemeColor = {
        primary: themeColor,
        ...otherColor,
      }
      return colors
    })
    const naiveTheme = computed(() => {
      return getNaiveTheme(themeColors.value)
    })
    function setupThemeVarsToHtml() {
      const { themeTokens, darkThemeTokens } = createThemeToken(themeColors.value)
      addThemeVarsToHtml(themeTokens as any, darkThemeTokens as any)
    }

    scope.run(() => {
      watch(
        themeColors,
        (val) => {
          setupThemeVarsToHtml()
          local.set('themeColor', val.primary)
        },
        { immediate: true },
      )
      watch(
        grayscaleMode,
        (val) => {
          toggleGrayscaleMode(val)
        },
        { immediate: true },
      )
      watch(
        darkMode,
        (val) => {
          toggleCssDarkMode(val)
        },
        { immediate: true },
      )
    })

    return {
      settings,
      darkMode,
      grayscaleMode,
      themeColors,
      naiveTheme,
    }
  },
})
